<template>
  <div class="flex flex-col bg-herodao-red mt-4 pt-4 pb-8 overflow-hidden">
    <div class="absolute right-0 overflow-hidden object-contain pointer-events-none">
      <img class="opacity-40 pointer-events-none" src="@/assets/dots.svg">
    </div>
    <div class="absolute left-0 overflow-hidden object-contain pointer-events-none">
      <img class="opacity-40 pointer-events-none" src="@/assets/dotsleft.svg">
    </div>
    <div class="flex flex-col space-y-2 space-x-2 mx-auto">
      <div class="flex font-aAhaWow sm:text-4xl sm:pt-2 pt-2 text-lg justify-center text-white">FAQ</div>
      <div class="flex text-white font-architects-daughter font-bold sm:text-3xl text-sm justify-center sm:pt-8">What is
        hero dao?
      </div>
      <div class="flex text-white font-avenir sm:text-xl sm:pt-4 text-xs justify-center">A DAO to reboot comic book
        heroes who have fallen into the public domain
      </div>
      <div class="flex text-white font-architects-daughter font-bold sm:text-3xl justify-center text-sm sm:pt-8">Where
        is hero dao going?
      </div>
      <div class="flex text-white font-avenir sm:text-xl sm:pt-4 text-xs justify-center">We're launching a real physical
        comic book, and a hero franchise where the IP is owned by the community
      </div>
      <div class="flex text-white font-architects-daughter font-bold sm:text-3xl justify-center text-sm sm:pt-8">What is
        a DAO
      </div>
      <div class="flex text-white font-avenir sm:text-xl sm:pt-4 text-xs justify-center">A Decentralized Autonomous
        Organization is a community of people making decisions together in a decentralized manner. A DAO is better at
        making decisions than other communities bc software automates executing the results of votes. A DAO can own IP
        collectively.
      </div>
      <div class="flex text-white font-architects-daughter font-bold sm:text-3xl justify-center text-sm sm:pt-8">What
        network is hero dao built on?
      </div>
      <div class="flex text-white font-avenir sm:text-xl sm:pt-4 text-xs justify-center"><a class="underline"
                                                                                            href="https://app.daohaus.club/dao/0x64/0x82b09c514d5427c8184b2fe7dc9fa632a6c05c26">DAOhaus&nbsp;</a>
        - a no code platform for Moloch DAOs
      </div>
      <div class="flex text-white font-architects-daughter font-bold sm:text-3xl justify-center text-sm sm:pt-8">How is
        hero dao controlled?
      </div>
      <div class="flex text-white font-avenir sm:text-xl sm:pt-4 text-xs justify-center">Lorem ipsum dolor sit amet,
        consectetur adipiscing elit, sed do eiusmod tempor incididunt ut
      </div>
      <div class="flex text-white font-architects-daughter font-bold sm:text-3xl justify-center text-sm sm:pt-8">How can
        I join?
      </div>
      <div class="flex text-white font-avenir sm:text-xl sm:pt-4 text-xs justify-center">Lorem ipsum dolor sit amet,
        consectetur adipiscing elit, sed do eiusmod tempor incididunt ut
      </div>
      <div class="flex text-white font-architects-daughter font-bold sm:text-3xl justify-center text-sm sm:pt-8">How can
        I contribute?
      </div>
      <div class="flex text-white font-avenir sm:text-xl sm:pt-4 text-xs justify-center">Lorem ipsum dolor sit amet,
        consectetur adipiscing elit, sed do eiusmod tempor incididunt ut
      </div>
      <div class="flex text-white font-architects-daughter font-bold sm:text-3xl justify-center text-sm sm:pt-8">What is
        hero dao building?
      </div>
      <div class="flex text-white font-avenir sm:text-xl sm:pt-4 text-xs justify-center">Lorem ipsum dolor sit amet,
        consectetur adipiscing elit, sed do eiusmod tempor incididunt ut
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "FaqContainer",
}
</script>